// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const lookupUsersApiUsersLookupGetParamsQMin = 2;
export const lookupUsersApiUsersLookupGetParamsQMax = 200;

export const LookupUsersApiUsersLookupGetParams = zod.object({
  "q": zod.string().min(lookupUsersApiUsersLookupGetParamsQMin).max(lookupUsersApiUsersLookupGetParamsQMax)
})

export type LookupUsersApiUsersLookupGetParams = zod.input<typeof LookupUsersApiUsersLookupGetParams>;
export type LookupUsersApiUsersLookupGetParamsOutput = zod.output<typeof LookupUsersApiUsersLookupGetParams>;
